import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ChipListAutocompleteComponent, IChipItem } from '../../lib/chip-list-autocomplete/chip-list-autocomplete.component';
import { ProviderFactory } from '../../lib/provider-factory';
import { IActionFieldMeta, MetaDataService, ToManyMeta } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';

@Component({
  selector: 'app-action-addremove',
  templateUrl: './add-remove.component.html',
  imports: [
    ChipListAutocompleteComponent
  ],
  styleUrls: ['../action.component.scss']
})
export class AddRemoveComponent extends BaseActionComponent implements AfterViewInit {

  @ViewChild(ChipListAutocompleteComponent)
  private pickerComponent: ChipListAutocompleteComponent;

  private toManyEntityTypeControl: FormControl;

  private static UNASSIGNED_OWNER_ID = 1;

  public constructor(protected metaDataService: MetaDataService, private providerFactory: ProviderFactory) {
    super(metaDataService);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.getMeta(this.destinationDescriptorControl.value)
        .subscribe((filteredMeta: IActionFieldMeta[]) => {

          const selField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
          this.resetItemsProvider(selField);
          this.destinationControlValueChange(selField);
        });
    }, 0);
  }

  protected initialiseControls() {
    this.destinationTypeControl.setValue('TO_MANY');

    this.valueControl.setValue(this.actionData.value ? this.actionData.value : []);
    this.valueControl.setValidators(Validators.required);

    this.toManyEntityTypeControl = new FormControl(this.actionData.entityType);
    this.formGroup.addControl('entityType', this.toManyEntityTypeControl);
  }

  protected destinationControlValueChange(selectedField: IActionFieldMeta): void {

    if (!selectedField) {
      this.toManyEntityTypeControl.setValue(null);
      this.pickerComponent.clearItems();
      return;
    }

    if (this.toManyEntityTypeChanged(selectedField.toManyType)) {
      this.pickerComponent.clearItems();
      this.pickerComponent.setItemsProvider(null);
      this.toManyEntityTypeControl.setValue(selectedField.toManyType);
      this.resetItemsProvider(selectedField);
    }
  }

  private toManyEntityTypeChanged(newToManyType: string): boolean {
    return this.toManyEntityTypeControl.value !== newToManyType;
  }

  private removeUnassignedUser(field: IActionFieldMeta, metas: ToManyMeta[]): ToManyMeta[] {
    if (field.fieldName === 'secondaryOwners')
      metas = metas.filter(m => m.id !== AddRemoveComponent.UNASSIGNED_OWNER_ID);
    return metas;
  }

  private resetItemsProvider (selectedField: IActionFieldMeta) {
    this.pickerComponent.loading();
    this.providerFactory.getItemsProvider(this.valueControl.value, selectedField).subscribe(([provider, selItems]) => {
      this.pickerComponent.setItemsProvider(provider, selItems);
      this.pickerComponent.loadComplete();
      this.valueControl.enable();
    });
  }
}
